import React, { useEffect, useState } from 'react';
import Form, { useForm } from '../../molecules/Form';
import Button from '../../molecules/Button';
import Field from '../Field';
import { LeadsDataStyle } from './CreateCompaign.styles';
import { useLocation, useNavigate } from 'react-router-dom';
import Toast from '../../molecules/Toast';
import campaignService from '../../../services/campaignService';
import CenterModal from '../../molecules/Modal/CenterModal';
import Loaders from '../Loaders';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';

const LeadsData = ({
  NextStep,
  setAddLeadsDataTab,
  csvInfo,
  setOpenLeadsModal,
  setActiveDataTab,
  onSuccess,
  data,
  setData,
  isInLeadsStep,
  leadsData,
  setStep,
}) => {
  const [form] = useForm();
  const location = useLocation();
  const campaignId = location?.state?.campaign_id;
  const [loading, setLoading] = useState(false);
  const campaign_type = location.state?.campaign_type;
  const leadsDataEmails = leadsData?.filter(item => item?.email);
  const { refetch } = useContextHook(AuthContext, v => ({
    refetch: v.refetch,
  }));

  // Check if leadsData is in loading phase (when leadsData?.length and leadsDataEmails?.length are not available)
  const isDataLoading = leadsData === undefined || leadsData === null;
  const getValidCount = value => {
    const numberValue = Number(value);
    return Number.isFinite(numberValue) ? numberValue : null;
  };
  const emailsFoundCount =
    getValidCount(csvInfo?.totalEmails) ??
    getValidCount(data?.step1?.emailCount) ??
    getValidCount(data?.mappedData?.leadList?.length) ??
    (isDataLoading ? 0 : getValidCount(leadsDataEmails?.length)) ??
    0;
  const contactsInListCount =
    getValidCount(csvInfo?.totalContacts) ??
    getValidCount(data?.step1?.leadCount) ??
    getValidCount(data?.mappedData?.leadList?.length) ??
    getValidCount(data?.step1?.rows?.length) ??
    (isDataLoading ? 0 : getValidCount(leadsData?.length)) ??
    0;

  const dataList = [
    {
      value: `${contactsInListCount}`,
      subtitle: 'Contacts in Lists',
    },
    {
      value: `${emailsFoundCount}`,
      subtitle: 'E-Mails found',
    },
    {
      value: `${csvInfo?.duplicateEmails?.length || 0}`,
      subtitle: 'Dublicates inside List',
    },
    { value: `0`, subtitle: 'Dublicates from other Lists' },
    {
      value: `${csvInfo?.blockedEmails?.length || data?.step1?.blacklistCounts || 0}`,
      subtitle: 'Blocklisted Domains',
    },
  ];

  const handleSubmit = async e => {
    if (location?.pathname === '/create-campaign') {
      if (isInLeadsStep) {
        try {
          setLoading(true);
          const payload = {
            leadList: data?.mappedData?.leadList,
          };
          const res = await campaignService?.addMoreLeadsToCampaign(
            data?.step2?.campaignId || data?.step6?.campaignId || campaignId,
            payload,
          );
          if (res.success) {
            Toast({ type: 'success', message: 'Leads Added Successfully' });
            setAddLeadsDataTab('leads');
            setOpenLeadsModal(false);
            refetch();
          }
        } catch (err) {
          Toast({ type: 'error', message: err.message });
        } finally {
          setLoading(false);
        }
      } else {
        if (data.step1.list_id) {
          setLoading(true);
          try {
            const payload = {
              campaignName: data?.step1?.campaign_name,
              list_id: data.step1.list_id,
              leads_type: 'houdiny_leads',
              ...(campaign_type === 'ai' && { campaignType: campaign_type }),
            };
            const res = await campaignService?.addNewLeadsToCampaign(payload);
            if (res.success) {
              Toast({ type: 'success', message: 'Houdiny Leads Added Successfully' });
              setData(prev => ({
                ...prev,
                step2: {
                  campaignId: res?.data?.campaignId,
                  campaignType: campaign_type,
                },
              }));
              setOpenLeadsModal(false);
              setAddLeadsDataTab('leads');

            }
          } catch (err) {
            Toast({ type: 'error', message: err.message });
          } finally {
            setLoading(false);
          }
        } else {
          try {
            setLoading(true);
            const payload = {
              campaignName: data?.step1?.campaign_name,
              leadList: data?.mappedData?.leadList,
              leads_type: 'csv_leads',
              columnNames: data?.mappedData?.columnNames,
              tagId: data?.step1?.tagId,

            };
            const res = await campaignService?.addLeadsToCompaign(payload);
            if (res.success) {
              Toast({ type: 'success', message: 'Leads Added Successfully' });
              setData(prev => ({
                ...prev,
                step2: {
                  leadList: data?.mappedData?.columnNames,
                  mappedRows: data?.mappedData?.leadList,
                  campaignId: res?.campaignId,
                  col_map_analysis: data?.mappedData?.col_map_analysis,
                  user_lead_created_at: res?.user_lead_created_at,
                },
                isHoudinyLeads: false,
              }));
              NextStep();
              setOpenLeadsModal(false);
              // setAddLeadsDataTab('leads');
            }
          } catch (err) {
            Toast({ type: 'error', message: err.message });
          } finally {
            setLoading(false);
          }
        }
      }
    }
  };

  function handleBack() {
    if (isInLeadsStep) {
      setAddLeadsDataTab('mapping');
    } else {
      setActiveDataTab('mapping');
    }
  }

  function handleCancel() {
    setOpenLeadsModal(false);
    if (isInLeadsStep) {
      setAddLeadsDataTab('leads');
    } else if (data?.step1?.list_id) {
      setOpenLeadsModal(false);
      setAddLeadsDataTab('leads');
      setStep(1);
    } else {
      setActiveDataTab('mapping');
    }
  }

  return (
    <>
      <CenterModal open={loading} setOpen={setLoading} width="600" noHead isCloseAble={false}>
        <div className="leads-modal">
          <strong className="heading">Processing your leads...</strong>
          <p>CSV file has many leads, so this may take some time ⏳</p>
          <Loaders dotsLoader dotsBottom />
        </div>
      </CenterModal>
      <LeadsDataStyle $btnWrapJustifyBetween={data?.step1?.list_id}>
        <Form form={form} onSubmit={handleSubmit}>
          <div className="content-wrap">
            <div className="head">
              <strong className="heading">Review & Import</strong>
              <p>Check your data and finish the setup.</p>
            </div>

            {/* ✅ Render dynamically from array */}
            <div className="data-holder">
              {dataList.map((item, index) => (
                <div className="data-col" key={index}>
                  <strong className="value">{item.value || 0}</strong>
                  <span className="subtitle">{item.subtitle}</span>
                </div>
              ))}
            </div>

            {/* <div className="checkbox-wrap">
              <Form.Item
                className="check-text"
                type="checkbox"
                rounded
                name="checkbox1"
                label="Update Duplicates from other lists"
                disabled>
                <Field />
              </Form.Item>

              <Form.Item
                className="check-text"
                type="checkbox"
                rounded
                name="checkbox2"
                label="Include Leads from other Team Members"
                disabled>
                <Field />
              </Form.Item>
            </div> */}
          </div>
          <div className="btn-holder">
            {!data?.step1?.list_id && (
              <Button newStyle rounded variant="outline" width="155px" type="button" onClick={() => handleBack()}>
                Back
              </Button>
            )}
            <div className="btn-wrap">
              <Button rounded newStyle variant="outline" width="155px" type="button" onClick={() => handleCancel()}>
                Cancel
              </Button>
              <Button newStyle rounded variant="darkBlue" type="submit" width="155px" loader={loading} disabled={loading}>
                {isInLeadsStep ? 'Import' : 'Finish'}
              </Button>
            </div>
          </div>
        </Form>
      </LeadsDataStyle>
    </>
  );
};

export default LeadsData;
